
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 400"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h800v400H0z","fill":"#002a8f"}}),_c('path',{attrs:{"d":"M0 80h800v80H0v80h800v80H0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M346.4 200L0 0v400z","fill":"#cf142b"}}),_c('path',{attrs:{"d":"M115.5 140l35.35 108.5-92.5-67h114.2l-92.5 67z","fill":"#fff"}})])
          )
        }
      }
    